exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".survey-modal p{font-size:14px}.survey-modal .modal-body .row{margin:0}.survey-modal .modal-body label{font-size:14px}.survey-modal .modal-body .form-check-input{margin:0 5px 0 0;position:relative;height:21px}.survey-modal .modal-body textarea{font-size:12px}.survey-modal .modal-body textarea.form-control{height:100px;padding:.375rem}.survey-modal .modal-body textarea.form-control:focus{-webkit-box-shadow:0 0 0 0.15rem rgba(44,62,80,0.25);box-shadow:0 0 0 0.15rem rgba(44,62,80,0.25)}.survey-modal .modal-header{border:none;padding:1rem 1rem .75rem 1rem}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/embeddable/SurveyModal.scss
// module id = 746
// module chunks = 1